module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input--label"
  }, [_c('label', {
    domProps: {
      "innerHTML": _vm._s(_vm.label)
    }
  }), _vm._v(" "), (_vm.required) ? _c('span', {
    staticClass: "input__asterisk"
  }, [_vm._v("*")]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-13895a10","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/inputLabelFullWidth.vue
// module id = 583
// module chunks = 0